import gql from 'graphql-tag';

export const ESIGNATURE_EVENT_NOTIFICATIONS = gql`
  query ($entityType: EsignatureEventNotificationEntityType!, $entityId: ID!) {
    esignatureEventNotifications(entityType: $entityType, entityId: $entityId) {
      id
      templateId
      templateName
      envelopeId
      status
      retryCount
      generatedDateTime
      statusChangedDateTime
    }
  }
`;
